import './App.css';
import './seo-pages.css';
import './performance.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BookingProvider } from '@/context/BookingContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';

const TreatmentsPage = lazy(() => import('@/pages/TreatmentsPage'));
const TreatmentDetail = lazy(() => import('@/pages/TreatmentDetail'));
const ConditionsPage = lazy(() => import('@/pages/ConditionsPage'));
const ConditionDetail = lazy(() => import('@/pages/ConditionDetail'));
const DoctorPage = lazy(() => import('@/pages/DoctorPage'));
const ReviewsPage = lazy(() => import('@/pages/ReviewsPage'));
const ContactPage = lazy(() => import('@/pages/ContactPage'));
const BlogIndex = lazy(() => import('@/pages/BlogIndex'));
const BlogPost = lazy(() => import('@/pages/BlogPost'));
const NotFound = lazy(() => import('@/pages/NotFound'));

function App() {
  return (
    <BrowserRouter>
      <BookingProvider>
        <Suspense fallback={null}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/treatments" element={<TreatmentsPage />} />
              <Route path="/treatments/:slug" element={<TreatmentDetail />} />
              <Route path="/conditions" element={<ConditionsPage />} />
              <Route path="/conditions/:slug" element={<ConditionDetail />} />
              <Route path="/about-doctor" element={<DoctorPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BookingProvider>
    </BrowserRouter>
  );
}

export default App;
